export default "__VITE_ASSET__aIvFO$yh__"